import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { Questions } from 'src/Models/Questions';
import { Surveys } from 'src/Models/Surveys';

@Component({
  selector: 'tpl-identify',
  templateUrl: './tpl-identify.component.html',
  styleUrls: ['./tpl-identify.component.sass']
})
export class TplIdentifyComponent implements OnInit {
  separateDialCode = true;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
	phoneForm = new FormGroup({
		phone: new FormControl(undefined, [Validators.required])
	});
  colorCheckbox = `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%230d6efd' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e")`;

  selectType: boolean = true;

  @Input() form: FormGroup;
  @Input() objColor: any;
  @Input() survey: Surveys;
  @Input() question: Questions;
  @Input() type_contact_response: string;
  @Input() btnSubmit: string;

  @Output() hiddenShowTitle = new EventEmitter<boolean>();
  @Output() nextStep = new EventEmitter<string>();
  
  validformat: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  finishQuestion() {
    if(!this.selectType || this.type_contact_response == 'Phone') {
      this.form.get('participant_key').setValue(this.form.get('participant_key').value['e164Number'].replace('+','').toString());
      this.form.get('participant_key').updateValueAndValidity();
    }
    this.form.get('anonymous').setValue(false);
    this.nextStep.emit('')
  }

  selectTypeKey(type) {
    this.form.get('participant_key').clearValidators();
    this.form.get('participant_key').setValidators(Validators.required);
    this.form.get('participant_key').updateValueAndValidity();
    this.form.get('participant_key').setValue('');
    this.selectType = type;
  }
  
  formIsValid() {
    return this.form.get('participant_key').errors == null &&
      this.form.get('name').errors == null &&
      this.form.get('termuse').errors == null &&
      (this.survey.show_consentiment_extra === false || this.form.get('termuse2').errors == null)
  }
}
